export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrzení"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zrušení"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ano"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jste si jisti, že chcete pokračovat?"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Smazat kryptoaktivum"])}
}